import Immutable from 'immutable'
import { createSelector } from 'reselect'

const EMPTY_DISCOUNT_DURATION = Immutable.Map()

// Falls back on a null or absent value alike: the API expresses "no duration" as either, and a
// stable empty Map keeps the memoised selector below from recomputing on every call.
export const getDiscountDuration = (offer) =>
  offer.get('discountDuration') || EMPTY_DISCOUNT_DURATION

export const getCreditFormatted = (offer) => offer.get('creditFormatted')
export const getOfferExpiry = (offer) => (offer.get('expiry') ? 'gold' : 'blue')
export const getYourFriendFirstBoxOffer = (offer) => offer.get('firstBoxDiscountFormatted')
export const getYourFriendFirstMonthOffer = (offer) => offer.get('firstMonthDiscountFormatted')
export const getYourFriendSecondBoxOffer = (offer) => offer.get('secondBoxDiscountFormatted')

export const getDiscountDurationFormatted = createSelector(
  getDiscountDuration,
  (discountDuration) => discountDuration.get('formatted'),
)

// Every value the share message and the invite surfaces around it interpolate.
export const isShareableOffer = (offer) =>
  Boolean(offer) &&
  Boolean(getYourFriendFirstBoxOffer(offer)) &&
  Boolean(getYourFriendSecondBoxOffer(offer)) &&
  Boolean(getYourFriendFirstMonthOffer(offer)) &&
  Boolean(getDiscountDurationFormatted(offer)) &&
  Boolean(getCreditFormatted(offer))
